import { httpGet } from "../Backend";
import HttpStatusCodes from "../HttpStatusCodes";

const root = "api/users";

export interface AccountRolesAndPermissionsViewModel {
    customerAccess: CustomerAccess[];
}

export interface CustomerAccess {
    customerName: string,
    accessModels: AccessModel[];
}

export interface AccessModel {
    descriptor: string | null;
    level: number;
}

export interface AccountRolesAndPermissionsResponse {
    accountRolesAndPermissionsViewModel: AccountRolesAndPermissionsViewModel;
}

export async function accountRolesAndPermissions(targetUserId: string) {
    var response = await httpGet(`${root}/accountRolesAndPermissions?targetUserId=${targetUserId}`)
    return response.data as AccountRolesAndPermissionsResponse;
}